const steps = [
  {
    number: '01',
    icon: 'ri-phone-line',
    title: 'Premier Contact',
    description: 'Contactez-nous par WhatsApp, email ou formulaire. Nous analysons votre situation et vos besoins spécifiques.'
  },
  {
    number: '02',
    icon: 'ri-file-search-line',
    title: 'Évaluation Gratuite',
    description: 'Consultation gratuite pour déterminer le type de visa adapté et évaluer vos chances de succès.'
  },
  {
    number: '03',
    icon: 'ri-folder-settings-line',
    title: 'Constitution du Dossier',
    description: 'Préparation complète de votre dossier avec tous les documents nécessaires et lettres professionnelles.'
  },
  {
    number: '04',
    icon: 'ri-checkbox-multiple-line',
    title: 'Vérification & Audit',
    description: 'Contrôle rigoureux de chaque document pour garantir la conformité et éviter tout risque de refus.'
  },
  {
    number: '05',
    icon: 'ri-user-voice-line',
    title: 'Préparation Entretien',
    description: 'Coaching personnalisé avec simulation d\'entretien pour vous préparer aux questions consulaires.'
  },
  {
    number: '06',
    icon: 'ri-send-plane-line',
    title: 'Soumission & Suivi',
    description: 'Dépôt de votre dossier et suivi régulier jusqu\'à l\'obtention de votre visa. Support continu.'
  }
];

export default function ProcessSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-blue-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-route-line text-blue-600"></i>
            <span className="text-blue-700 text-sm font-semibold">Notre Processus</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Comment Nous Travaillons
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Un processus simple, transparent et efficace pour maximiser vos chances d'obtenir votre visa
          </p>
        </div>

        <div className="relative">
          {/* Ligne de connexion */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-teal-200 via-blue-200 to-teal-200 transform -translate-y-1/2 z-0"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 relative z-10">
            {steps.map((step, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-2 border-gray-100 hover:border-teal-200"
              >
                <div className="flex items-start space-x-4 mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-blue-600 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                  <div className="text-5xl font-bold text-teal-100">
                    {step.number}
                  </div>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {step.title}
                </h3>

                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>

                <div className="mt-6 pt-6 border-t border-gray-100">
                  <div className="flex items-center text-sm text-teal-600 font-semibold">
                    <i className="ri-arrow-right-line mr-2"></i>
                    Étape {step.number}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 bg-gradient-to-br from-blue-50 to-teal-50 rounded-3xl p-12 text-center">
          <div className="max-w-3xl mx-auto">
            <i className="ri-time-line text-5xl text-teal-600 mb-6"></i>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Délais de Traitement Rapides
            </h3>
            <p className="text-lg text-gray-600 mb-8">
              En moyenne, nos clients obtiennent leur visa en 2 à 4 semaines selon le type de visa et le pays de destination. Nous optimisons chaque étape pour accélérer le processus.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="text-3xl font-bold text-teal-600 mb-2">24h</div>
                <div className="text-gray-700 font-medium">Première Réponse</div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="text-3xl font-bold text-teal-600 mb-2">3-5j</div>
                <div className="text-gray-700 font-medium">Constitution Dossier</div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="text-3xl font-bold text-teal-600 mb-2">2-4s</div>
                <div className="text-gray-700 font-medium">Obtention Visa</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
